import { useEffect, useState } from "react";

interface Props {
  name: string;
  hours: number;
  maxHours?: number;
}

const TimeItem = ({ name, hours, maxHours = 8 }: Props) => {
  const [barStyles, setBarStyles] = useState({ width: "0%", colorClass: "bg-gray-300" });
  
  const calculateWidth = () => {
    const percentage = (hours / maxHours) * 100;
    return `${Math.min(percentage, 100)}%`;
  };

  const getBarColor = () => {
    if (hours >= 8) return "bg-green-500";
    if (hours > 7.75) return "bg-green-400";
    if (hours > 7.5) return "bg-green-300";
    if (hours > 7.25) return "bg-green-200";
    if (hours > 7) return "bg-lime-400";
    if (hours > 6.75) return "bg-lime-500";
    if (hours > 6.5) return "bg-lime-600";
    if (hours > 6.25) return "bg-lime-700";
    if (hours > 6) return "bg-yellow-400";
    if (hours > 5.75) return "bg-yellow-500";
    if (hours > 5.5) return "bg-yellow-600";
    if (hours > 5.25) return "bg-yellow-700";
    if (hours > 5) return "bg-amber-400";
    if (hours > 4.75) return "bg-amber-500";
    if (hours > 4.5) return "bg-amber-600";
    if (hours > 4.25) return "bg-amber-700";
    if (hours > 4) return "bg-orange-400";
    if (hours > 3.75) return "bg-orange-500";
    if (hours > 3.5) return "bg-orange-600";
    if (hours > 3.25) return "bg-orange-700";
    if (hours > 3) return "bg-red-400";
    if (hours > 2.75) return "bg-red-500";
    if (hours > 2.5) return "bg-red-600";
    if (hours > 2.25) return "bg-red-700";
    if (hours > 2) return "bg-red-800";
    if (hours > 1.75) return "bg-red-900";
    if (hours > 1.5) return "bg-rose-600";
    if (hours > 1.25) return "bg-rose-700";
    if (hours > 1) return "bg-rose-800";
    if (hours > 0.75) return "bg-rose-900";
    if (hours > 0.5) return "bg-pink-600";
    if (hours > 0.25) return "bg-pink-700";
    if (hours > 0) return "bg-pink-800";
    return "bg-gray-300";
  };

  useEffect(() => {
    setBarStyles({
      width: calculateWidth(),
      colorClass: getBarColor()
    });
  }, [hours, maxHours]);

  return (
    <div className="flex items-center gap-4 p-2">
      <b className="text-lg w-24">
        {name}
      </b>
      
      <div className="flex-1">
        <div className="relative h-8 bg-gray-200 rounded-full overflow-hidden">
          <div 
            className={`h-full rounded-full transition-all duration-300 ${barStyles.colorClass}`}
            style={{
              width: barStyles.width
            }}
          />
        </div>
        
        <p className="text-sm text-gray-600 mt-1">
          {hours} uur
        </p>
      </div>
    </div>
  );
};

export default TimeItem;